"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import {
  html,
  nothing,
  SpectrumElement
} from "@spectrum-web-components/base";
import { property } from "@spectrum-web-components/base/src/decorators.js";
import {
  FocusVisiblePolyfillMixin,
  ObserveSlotPresence,
  ObserveSlotText
} from "@spectrum-web-components/shared";
import tabItemStyles from "./tab.css.js";
const _Tab = class _Tab extends FocusVisiblePolyfillMixin(
  ObserveSlotText(ObserveSlotPresence(SpectrumElement, '[slot="icon"]'), "")
) {
  constructor() {
    super(...arguments);
    this.disabled = false;
    this.label = "";
    this.selected = false;
    this.vertical = false;
    this.value = "";
  }
  static get styles() {
    return [tabItemStyles];
  }
  get hasIcon() {
    return this.slotContentIsPresent;
  }
  get hasLabel() {
    return !!this.label || this.slotHasContent;
  }
  render() {
    return html`
            ${this.hasIcon ? html`
                      <slot name="icon"></slot>
                  ` : nothing}
            <label id="item-label" ?hidden=${!this.hasLabel}>
                ${this.slotHasContent ? nothing : this.label}
                <slot>${this.label}</slot>
            </label>
        `;
  }
  firstUpdated(changes) {
    super.firstUpdated(changes);
    this.setAttribute("role", "tab");
    if (!this.hasAttribute("id")) {
      this.id = `sp-tab-${_Tab.instanceCount++}`;
    }
  }
  updated(changes) {
    super.updated(changes);
    if (changes.has("selected")) {
      this.setAttribute(
        "aria-selected",
        this.selected ? "true" : "false"
      );
      this.setAttribute("tabindex", this.selected ? "0" : "-1");
    }
    if (changes.has("disabled")) {
      if (this.disabled) {
        this.setAttribute("aria-disabled", "true");
      } else {
        this.removeAttribute("aria-disabled");
      }
    }
  }
};
/**
 * @private
 */
_Tab.instanceCount = 0;
__decorateClass([
  property({ type: Boolean, reflect: true })
], _Tab.prototype, "disabled", 2);
__decorateClass([
  property({ reflect: true })
], _Tab.prototype, "label", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], _Tab.prototype, "selected", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], _Tab.prototype, "vertical", 2);
__decorateClass([
  property({ type: String, reflect: true })
], _Tab.prototype, "value", 2);
export let Tab = _Tab;
//# sourceMappingURL=Tab.dev.js.map
